export default "__VITE_ASSET__Cb5LyI8v__"